<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
    <thead>
      <tr>

        <th class="disabled-sorting no-sort" style="width: 80px;">
          <b style="display: flex">
            <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
              <i class="fa {{checkAll() ? 'fa-check-square' : 'fa-square-o'}}" aria-hidden="true"></i>
            </a>
            <a *ngIf="bulk.length > 0" class="btn btn-link btn-default btn-just-icon" title="Clean Selected" (click)="cleanBulk()">
              <i class="material-icons">cleaning_services</i>
            </a>
            </b>
          </th>

        <th class="order" (click)="sort('id')"> <i [ngStyle]="{'color':orderby === 'id' ? 'blue' : 'black' }" class="fa {{ sorting('id') }}"></i><b style="margin-left: 5px;">ID</b></th>
        <th class="order" (click)="sort('po')"> <i [ngStyle]="{'color':orderby === 'po' ? 'blue' : 'black' }" class="fa {{ sorting('po') }}"></i><b style="margin-left: 5px;">PO #</b></th>
        <th class="order" (click)="sort('item')"> <i [ngStyle]="{'color':orderby === 'item' ? 'blue' : 'black' }" class="fa {{ sorting('item') }}"></i><b style="margin-left: 5px;">Container Type</b></th>
        <th class="order" (click)="sort('damages')"> <i [ngStyle]="{'color':orderby === 'damages' ? 'blue' : 'black' }" class="fa {{ sorting('damages') }}"></i><b style="margin-left: 5px;">Damage</b></th>
        <th class="order" (click)="sort('createdat')"> <i [ngStyle]="{'color':orderby === 'createdat' ? 'blue' : 'black' }" class="fa {{ sorting('createdat') }}"></i><b style="margin-left: 5px;">Date Received</b></th>
        <th class="order" (click)="sort('updatedat')"> <i [ngStyle]="{'color':orderby === 'updatedat' ? 'blue' : 'black' }" class="fa {{ sorting('updatedat') }}"></i><b style="margin-left: 5px;">Last Updated</b></th>
        <th class="order" (click)="sort('internallocation')"> <i [ngStyle]="{'color':orderby === 'internallocation' ? 'blue' : 'black' }" class="fa {{ sorting('internallocation') }}"></i><b style="margin-left: 5px;">Location</b></th>
        <th class="order" (click)="sort('ispi')"> <i [ngStyle]="{'color':orderby === 'ispi' ? 'blue' : 'black' }" class="fa {{ sorting('ispi') }}"></i><b style="margin-left: 5px;">Stage</b></th>
        <th class="order" (click)="sort('typeequipment')"> <i [ngStyle]="{'color':orderby === 'typeequipment' ? 'blue' : 'black' }" class="fa {{ sorting('typeequipment') }}"></i><b style="margin-left: 5px;">Type Of Equipment</b></th>
        <th class="order" (click)="sort('rep')"> <i [ngStyle]="{'color':orderby === 'rep' ? 'blue' : 'black' }" class="fa {{ sorting('rep') }}"></i><b style="margin-left: 5px;">Container Creator</b></th>
        <th class="text-right"><b>Actions</b></th>

      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer;" *ngFor="let item of data">

        <td style="width: 30px;">
          <a class="btn btn-link btn-info btn-just-icon" (click)="selectItem(item.id)">
            <i class="material-icons">{{check(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
          </a>
        </td>
        <td style="width: 50px;">{{item.id}}</td>
        <td style="width: 50px;">{{item.po.po}}</td>
        <td>{{item.item}}</td>
        <td>{{item.damages}}</td>
        <td>{{item.createdAt | date : 'MM-dd-yyyy'}}</td>
        <td>{{item.updatedAt | date : 'MM-dd-yyyy'}}</td>
        <td style="width: 300px;">
          {{item.internalLocation !== null ? item.internalLocation.locationName  + ': ' + item.internalLocation.locationRow + ' - ' +
          item.internalLocation.locationBay + ' - ' + item.internalLocation.locationLevel + ' - ' + item.internalLocation.locationSection : ''}}
        </td>
        <td>{{item.isPi | Showstage}}</td>
        <td>{{item.typeEquipment}}</td>
        <td>{{item.rep !== null ? (item.rep.name + ' ' + item.rep.surname) : ''}}</td>
        <td style="text-align: right">

          <a *ngIf="item.pictureRequired || item.damages === 'Yes'" class="btn btn-link btn-primary btn-just-icon">
            <i class="material-icons emitir" id="photos-{{item.id}}">collections</i>
          </a>

          <a *ngIf="item.chatLogs === 1"  class="btn btn-link btn-warning btn-just-icon">
            <i class="material-icons emitir" id="chat-{{item.id}}">chat_bubble</i>
          </a>

          <a class="btn btn-link btn-info btn-just-icon" title="Detail">
            <i class="material-icons emitir" id="show-{{item.id}}">remove_red_eye</i>
          </a>

          <a *ngIf="(!item.pictureRequired && item.damages !== 'Yes') || item.numPhotos" class="btn btn-link btn-dark btn-just-icon" title="Print">
            <i class="material-icons emitir" id="print-{{item.id}}">local_printshop</i>
          </a>

          <a class="btn btn-link btn-info btn-just-icon" *ngIf="item.po.processingId" title="Processing Instructions">
            <i class="material-icons emitir" id="processing-{{item.id}}">account_tree</i>
          </a>

          <a class="btn btn-link btn-dark btn-just-icon" *ngIf="item.pending" title="Ticket">
            <i class="material-icons emitir" id="ticket-{{item.pending}}">confirmation_number</i>
          </a>

          <a class="btn btn-link btn-danger btn-just-icon" title="Remove">
            <i class="material-icons emitir" id="delete-{{item.id}}">close</i>
          </a>

        </td>
      </tr>
    </tbody>

  </table>
</div>


<style>
  .order {
    cursor: pointer;
  }
</style>